'use client';

import type { ButtonBlock } from '@impact/types';
import { cn } from '@/lib/utils';
import { ArrowRight } from 'lucide-react';

interface Props {
  block: ButtonBlock;
  editing?: boolean;
}

/**
 * Arrow link variant: text + arrow, no button background
 */
export function ButtonArrowLink({ block, editing }: Props) {
  const { text, url, alignment = 'left', openInNewTab = false } = block.data;

  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  } as const;

  return (
    <div className={cn('my-6', alignClasses[alignment])}>
      <a
        href={editing ? '#' : url}
        onClick={editing ? (e) => e.preventDefault() : undefined}
        {...(!editing && openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        className="group inline-flex items-center gap-2 font-semibold text-primary hover:text-primary/80 transition-colors"
      >
        <span {...(editing ? { 'data-editable': 'data.text' } : {})}>{text}</span>
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </a>
    </div>
  );
}
